import React from "react";

function Icon({ className }) {
  return (
    <svg
      width="145"
      height="19"
      viewBox="0 0 145 19"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.1955H3.73896L7.83645 8.733L11.9339 2.1955H15.6729V17.6384H12.2413V7.54904L7.83645 14.138H7.73402L3.38043 7.60052V17.6384H0V2.1955Z"
        fill="#101211"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.4434 9.96847C35.4434 5.59297 38.875 1.98962 43.6383 1.98962C46.4554 1.98962 48.1456 2.71029 49.7846 4.10016L47.6334 6.6225C46.5128 5.60254 45.0475 5.05028 43.5359 5.07821C42.3087 5.11858 41.1468 5.64405 40.3029 6.54045C39.4589 7.43684 39.001 8.63174 39.0287 9.86551C39.0004 10.5065 39.1035 11.1466 39.3316 11.7459C39.5596 12.3452 39.9078 12.8911 40.3544 13.3496C40.801 13.8081 41.3366 14.1695 41.9279 14.4114C42.5193 14.6533 43.1537 14.7705 43.792 14.7558C44.9367 14.7868 46.0632 14.4633 47.0188 13.8292V11.6672H43.5359V8.73303H50.348V15.4764C48.4695 17.0602 46.0902 17.9181 43.6383 17.8958C38.7726 17.8958 35.4434 14.5499 35.4434 9.96847Z"
        fill="#101211"
      />
      <path
        d="M57.2627 2.1955H53.8311V17.6487H57.2627V2.1955Z"
        fill="#101211"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.4894 9.96847C60.4894 5.59297 63.8699 1.98962 68.6844 1.98962C71.6551 1.98962 73.3965 2.96768 74.8819 4.35754L72.6795 6.87988C71.4502 5.79888 70.221 5.12969 68.6332 5.12969C66.0211 5.12969 64.126 7.2917 64.126 9.91699C64.126 12.5938 65.9698 14.7558 68.6332 14.7558C70.4259 14.7558 71.5527 14.0866 72.7819 12.9541L74.9843 15.1676C74.1782 16.076 73.1806 16.7923 72.0642 17.2643C70.9477 17.7363 69.7406 17.952 68.5308 17.8958C67.4802 17.9235 66.4349 17.7385 65.457 17.3518C64.479 16.9652 63.5884 16.3848 62.8382 15.6452C62.088 14.9056 61.4934 14.0219 61.0899 13.0467C60.6864 12.0715 60.4822 11.0246 60.4894 9.96847Z"
        fill="#101211"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.4668 2.1955H81.8984V14.5498H89.7349V17.6384H78.4668V2.1955Z"
        fill="#101211"
      />
      <path d="M95.9326 2.1955H92.501V17.6487H95.9326V2.1955Z" fill="#101211" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.8252 2.1955H103.001L110.376 11.7186V2.1955H113.757V17.6384H110.837L103.257 7.80642V17.6384H99.8252V2.1955Z"
        fill="#101211"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M117.547 2.1955H120.979V8.93891L127.33 2.1955H131.53L125.127 8.733L131.786 17.6384H127.637L122.822 11.0494L120.979 12.9026V17.6384H117.547V2.1955Z"
        fill="#101211"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M132.605 15.3735L134.603 13.0056C136.037 14.1381 137.522 14.8587 139.315 14.8587C141.107 14.8587 141.568 14.344 141.568 13.4174C141.568 12.5423 141.005 12.1305 138.393 11.4613C135.781 10.7921 133.22 9.81403 133.22 6.72545C133.22 3.94572 135.473 2.09257 138.7 2.09257C140.814 2.03596 142.881 2.72837 144.539 4.04867L142.746 6.6225C141.571 5.69717 140.14 5.158 138.649 5.0782C137.317 5.0782 136.651 5.69592 136.651 6.41659C136.651 7.44612 137.317 7.75498 140.032 8.47565C142.746 9.19632 145 10.3803 145 13.1085C145 16.1971 142.644 17.9473 139.212 17.9473C136.767 17.9494 134.41 17.0311 132.605 15.3735Z"
        fill="#101211"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.9115 1.47484L29.2969 1.68075L29.092 2.24699L28.9384 1.68075L28.3237 1.47484L28.9384 1.32041L29.092 0.702698L29.2969 1.32041L29.9115 1.47484Z"
        fill="#101211"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.1238 2.19553L23.2531 2.50439L22.9458 3.37949L22.6897 2.50439L21.7678 2.19553L22.6897 1.93815L22.9458 1.06305L23.2531 1.93815L24.1238 2.19553ZM23.2531 4.46049L21.4605 5.02673L20.8971 6.82841L20.3337 5.02673L18.541 4.46049L20.3337 3.94573L20.8971 2.14405L21.4605 3.94573L23.2531 4.46049ZM31.8066 2.71029L30.8847 2.96768L30.5774 3.89425L30.3213 2.96768L29.3994 2.71029L30.3213 2.45291L30.5774 1.52634L30.8847 2.45291L31.8066 2.71029Z"
        fill="#101211"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9408 2.71027L25.6604 2.19551L24.2263 5.54148L25.4555 6.10772L26.9408 2.71027ZM27.9652 2.29846L21.4604 17.7929L21.1531 18.1017C21.0214 18.1534 20.8751 18.1534 20.7434 18.1017L18.8483 17.2266C18.7119 17.1647 18.6026 17.0549 18.541 16.9178C18.4902 16.7675 18.4902 16.6047 18.541 16.4545L25.1994 1.11451C25.2965 1.00085 25.4195 0.912534 25.5579 0.857124C25.6897 0.805438 25.8359 0.805438 25.9677 0.857124L27.6579 1.57779C27.7305 1.59991 27.7964 1.63967 27.8501 1.69354C27.9037 1.74741 27.9432 1.81374 27.9652 1.88665C28.0166 2.01906 28.0166 2.16606 27.9652 2.29846Z"
        fill="#101211"
      />
      <path
        d="M24.9436 11.2039H28.4265L26.685 6.93132L28.324 2.86469L34.7264 17.6384H31.0898L29.6557 14.1895H23.7144L24.9436 11.2039Z"
        fill="#101211"
      />
    </svg>
  );
}

export default Icon;
